import { reactive, ref } from 'vue';

const instance = ref(null);
class Auth {
  is_authenticated = ref(false);

  constructor() {
    instance.value = this;
  }
}
export const getInstance = () => instance.value;

export const AuthPlugin = {
  install(app, options) {
    app.config.globalProperties.$auth = reactive(new Auth(options));
  },
};
